import { Checkbox, Form, Input, message, Modal, Radio, Select } from "antd";
import { useEffect, useState } from "react";
import validator from 'validator';
import { useDispatch, useSelector } from "react-redux";
import { user_role } from "../consts";
import { useCreateUser, useGetAllCompanies, useGetAllUsers, useUpdateUser } from "../utils/queryUtils";
import { setReloadUser } from "../store/action/reload";

export default function CreateUsers({ show, setShow, selectedUser, setSelectedUser, company }) {
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();


    let dispatch = useDispatch();

    const layout = {
        labelCol: { span: 24 },
        wrapperCol: { span: 24 },
    };

    const { Option } = Select;
    let { _id } = useSelector((st) => st.user);
    const userData = useSelector((st) => st.user);
    const { data: allCompanies } = useGetAllCompanies(_id);
    const all = allCompanies;
    const allUserWithinCache = useGetAllUsers();
    const allUsers = allUserWithinCache?.data;
    const { mutateAsync: createUser } = useCreateUser();
    const { mutateAsync: updateUser } = useUpdateUser();
    const { reloadUser } = useSelector(st => st.reload);

    useEffect(() => {
        if (reloadUser) {
            allUserWithinCache.refetch()
            dispatch(setReloadUser(false));
        }
    }, [reloadUser])
    async function submit(values) {
        if (values.role === 'ADMIN') {
            values.company_ids = []
        }
        setLoading(true);
        try {
            const res = selectedUser ? await updateUser({ userId: selectedUser, userData: values }) : await createUser({ userData: { ...values, companyName: values.role === 'ADMIN' ? '' : values.companyName } });
            if (res) {
                message.success(selectedUser ? "User updated successfully" : "User created successfully");
                setSelectedUser(null);
                dispatch(setReloadUser(true))
                setShow(false);
                form.resetFields()
            }
            else {
                message.error("User operation failed");
            }
        } catch (err) {
            message.error(err ? (err.response?.data?.message || err.response?.data?.response) : "Some error occurred");
            console.error(err);
        } finally {
            setLoading(false);
        }
    }

    useEffect(() => {
        if (selectedUser) {
            let initial = allUsers?.data?.filter(e => e._id === selectedUser) || [];
            if (initial.length > 0) {
                const companyNames = initial[0]?.company_ids?.map(e => e._id);
                const selectedValues = { ...initial[0] };
                selectedValues.company_ids = companyNames;
                form.setFieldsValue(selectedValues);
            }
            } else {
                if (company) {
                    const companyId = all?.filter(e => e.name === company);
                  
                    form.setFieldsValue({ company_ids: companyId[0]?._id ? [companyId[0]._id] : [] })
                }
                else {
                    form.resetFields()
                }
            }
    }, [form, selectedUser, allUsers, company]);

    const passwordValidator = (value) => {
        return validator.isStrongPassword(value);
    }


    const getInitialRole = (role) => {
        switch (role) {
            case user_role.STAFF:
                return user_role.PRIMARY_CLIENT;
            case user_role.ACCOUNTANT:
                {
                    if (userData.can_invite_accountant) {
                        return user_role.ACCOUNTANT;
                    }
                    else if (userData.can_invite_staff) {
                        return user_role.STAFF;
                    }
                    else return role;
                }
            default:
                return role;
        }
    }

    return (
        <Modal open={show}
            title={selectedUser ? 'Edit User' : 'Add User'}
            onCancel={() => setShow(false)}
            okText={selectedUser ? 'Update User' : 'Add User'}
            onOk={() => {
                form
                    .validateFields()
                    .then(values => {
                        form.resetFields();
                        submit(values);
                    })
                    .catch(info => {
                        console.error('Validate Failed:', info);
                    });
            }}
            okButtonProps={{ loading: loading, htmlType: "submit" }}
            cancelButtonProps={{ loading }}
            destroyOnClose={true}
        >
            {
                selectedUser ?
                    <Form
                        layout="vertical" {...layout}
                        onFinish={submit} form={form}
                        initialValues={allUsers?.data?.find(e => e._id === selectedUser)}
                    >
                        <Form.Item
                            label="First Name"
                            name="first_name"
                            rules={[{ required: true, message: 'First name is required' }]}
                        >
                            <Input placeholder="John" />
                        </Form.Item>
                        <Form.Item
                            label="Last Name"
                            name="last_name"
                            rules={[{ required: true, message: 'Last name is required' }]}
                        >
                            <Input placeholder="Doe" />
                        </Form.Item>
                        <Form.Item
                            label="Email"
                            name="email"
                            rules={[{ required: true, message: 'Email is required' }]}
                        >
                            <Input placeholder="test@example.com" type='email' disabled />
                        </Form.Item>
                        <Form.Item
                            label="Role"
                            name="role"
                            rules={[{ required: true, message: 'Role is required' }]}
                        >
                            <Select
                                disabled={form.getFieldValue("role") === "PRIMARY_CLIENT"}
                                placeholder="Select a role"
                            >
                                {userData?.role === "ACCOUNTANT" ? (
                                    <>
                                        {userData?.can_invite_staff && (
                                            <Option value="STAFF">Australian Staff</Option>
                                        )}
                                        {userData?.can_invite_accountant && (
                                            <Option value="ACCOUNTANT">Accountant</Option>
                                        )}
                                    </>
                                ) : (
                                    <>
                                        <Option value="ADMIN">Admin</Option>
                                        <Option value="ACCOUNTANT">Accountant</Option>
                                        <Option value="STAFF">Australian Staff</Option>
                                    </>
                                )}
                            </Select>
                        </Form.Item>


                        {
                            userData?.role !== user_role.ACCOUNTANT && (
                                <Form.Item noStyle shouldUpdate={(prev, curr) => prev.role !== curr.role}>
                                    {({ getFieldValue }) => {
                                        const role = getFieldValue('role');

                                        if (role === user_role.ACCOUNTANT) {
                                            return (
                                                <>
                                                    <Form.Item
                                                        label="Accountant Permissions"
                                                        name="can_invite_accountant"
                                                        valuePropName="checked"
                                                    >
                                                        <Checkbox>Allow this user to invite Accountants</Checkbox>
                                                    </Form.Item>
                                                    <Form.Item
                                                        label="Staff Permissions"
                                                        name="can_invite_staff"
                                                        valuePropName="checked"
                                                    >
                                                        <Checkbox>Allow this user to invite Staff</Checkbox>
                                                    </Form.Item>
                                                </>
                                            );
                                        }

                                        if (role === user_role.STAFF) {
                                            return (
                                                <Form.Item
                                                    label="Primary Client"
                                                    name="can_invite_primary_client"
                                                    valuePropName="checked"
                                                >
                                                    <Checkbox>Allow this user to invite a primary client</Checkbox>
                                                </Form.Item>
                                            );
                                        }

                                        return null;
                                    }}
                                </Form.Item>
                            )
                        }

                        <Form.Item
                            noStyle
                            shouldUpdate={(prevValues, currentValues) => prevValues.role !== currentValues.role}
                        >
                            {({ getFieldValue }) => {
                                    const role = getFieldValue('role');

                                    return (
                                        <Form.Item
                                            label="Firm"
                                            name="company_ids"
                                            rules={[
                                                {
                                                    validator: async (_, value) => {
                                                        if (role === user_role.ACCOUNTANT) {
                                                            if (!value || value.length < 1) {
                                                                return Promise.reject(new Error('Please assign at least one company to the user'));
                                                            }
                                                        } else if (role === user_role.STAFF || role === user_role.PRIMARY_CLIENT) {
                                                            if (!value || value.length !== 1) {
                                                                return Promise.reject(new Error('Exactly one company must be assigned to a user with this role'));
                                                            }
                                                        }
                                                    },
                                                },
                                            ]}
                                        >
                                            <Select
                                                mode="multiple"
                                                maxCount={role === user_role.STAFF || role === user_role.PRIMARY_CLIENT ? 1 : undefined}
                                                disabled={role === user_role.ADMIN}
                                                showSearch
                                                filterOption={(input, option) =>
                                                    option?.label?.toLowerCase().includes(input.toLowerCase())
                                                }
                                                options={
                                                    all?.map(e => ({
                                                        value: e._id,
                                                        label: e.name,
                                                    }))
                                                }
                                            />
                                        </Form.Item>
                                    );
                                }}
                        </Form.Item>

                        <Form.Item
                            label="Status"
                            name="status"
                            rules={[{ required: true, message: 'Status is required' }]}
                        >
                            <Radio.Group
                                options={[
                                    { label: 'Active', value: 'ACTIVE' },
                                    { label: 'Suspended', value: 'SUSPENDED' }
                                ]}
                                optionType="button"
                                buttonStyle="solid"
                            />
                        </Form.Item>
                    </Form>
                    :
                    <Form
                        layout="vertical" {...layout}
                        onFinish={submit} form={form}
                    >
                        <Form.Item
                            label="First Name"
                            name="first_name"
                            rules={[{ required: true, message: 'First name is required' }]}
                        >
                            <Input placeholder="John" />
                        </Form.Item>
                        <Form.Item
                            label="Last Name"
                            name="last_name"
                            rules={[{ required: true, message: 'Last name is required' }]}
                        >
                            <Input placeholder="Doe" />
                        </Form.Item>
                        <Form.Item
                            label="Email"
                            name="email"
                            rules={[{ required: true, message: 'Email is required' }]}
                        >
                            <Input placeholder="test@example.com" type='email' />
                        </Form.Item>
                        <Form.Item
                            label="Password"
                            name="password"
                            rules={[{ required: true, message: 'Password is required' }, {
                                validator: (rule, value) => {
                                    if (passwordValidator(value)) {
                                        return Promise.resolve();
                                    }
                                    return Promise.reject('Password must contain at least 8 characters, 1 uppercase, 1 lowercase, 1 number and 1 special character');
                                }
                            }]}
                        >
                            <Input.Password placeholder="*******" type='password' autoComplete="new-password" />
                        </Form.Item>
                        <Form.Item
                            label="Role"
                            name="role"
                            rules={[{ required: true, message: 'Role is required' }]}
                            initialValue={getInitialRole(userData.role)}
                        >
                            {userData.role === user_role.ACCOUNTANT ? (
                                <Select placeholder="Select a role">
                                    {userData.can_invite_accountant && (
                                        <Option value="ACCOUNTANT">Accountant</Option>
                                    )}
                                    {userData.can_invite_staff && (
                                        <Option value="STAFF">Australian Staff</Option>
                                    )}
                                </Select>
                            ) : userData.role === "STAFF" ? (
                                <Select disabled>
                                    <Option value="PRIMARY_CLIENT">Primary Client</Option>
                                </Select>
                            ) : (
                                <Select placeholder="Select a role">
                                    <Option value="ADMIN">Admin</Option>
                                    <Option value="ACCOUNTANT">Accountant</Option>
                                    <Option value="STAFF">Australian Staff</Option>
                                    <Option value="PRIMARY_CLIENT">Primary Client</Option>
                                </Select>
                            )}
                        </Form.Item>

                        {userData?.role !== user_role.ACCOUNTANT && (
                            <Form.Item noStyle shouldUpdate={(prev, curr) => prev.role !== curr.role}>
                                {({ getFieldValue }) => {
                                    const role = getFieldValue('role');

                                    if (role === user_role.ACCOUNTANT) {
                                        return (
                                            <>
                                                <Form.Item
                                                    label="Accountant Permissions"
                                                    name="can_invite_accountant"
                                                    valuePropName="checked"
                                                >
                                                    <Checkbox>Allow this user to invite Accountants</Checkbox>
                                                </Form.Item>
                                                <Form.Item
                                                    label="Staff Permissions"
                                                    name="can_invite_staff"
                                                    valuePropName="checked"
                                                >
                                                    <Checkbox>Allow this user to invite Staff</Checkbox>
                                                </Form.Item>
                                            </>
                                        );
                                    }

                                    if (role === user_role.STAFF) {
                                        return (
                                            <Form.Item
                                                label="Primary Client"
                                                name="can_invite_primary_client"
                                                valuePropName="checked"
                                            >
                                                <Checkbox>Allow this user to invite a primary client</Checkbox>
                                            </Form.Item>
                                        );
                                    }
                                    return null;
                                }}
                            </Form.Item>
                        )}


                        <Form.Item
                            noStyle
                            shouldUpdate={(prevValues, currentValues) => prevValues.role !== currentValues.role}
                        >
                            {({ getFieldValue }) => {
                                const role = getFieldValue('role');

                                return (
                                    <Form.Item
                                        label="Firm"
                                        name="company_ids"
                                        rules={[
                                            {
                                                validator: async (_, value) => {
                                                    if (role === user_role.ACCOUNTANT) {
                                                        if (!value || value.length < 1) {
                                                            return Promise.reject(new Error('Please assign at least one company to the user'));
                                                        }
                                                    } else if (role === user_role.STAFF || role === user_role.PRIMARY_CLIENT) {
                                                        if (!value || value.length !== 1) {
                                                            return Promise.reject(new Error('Exactly one company must be assigned to a user with this role'));
                                                        }
                                                    }
                                                },
                                            },
                                        ]}

                                    >
                                        <Select
                                            mode="multiple"
                                            disabled={role === user_role.ADMIN}
                                            showSearch
                                            filterOption={(input, option) =>
                                                option?.label?.toLowerCase().includes(input.toLowerCase())
                                            }
                                            maxCount={role === user_role.STAFF || role === user_role.PRIMARY_CLIENT ? 1 : undefined}
                                            options={
                                                all?.map(e => ({
                                                    value: e._id,
                                                    label: e.name,
                                                }))
                                            }
                                        />
                                    </Form.Item>
                                );
                            }}
                        </Form.Item>

                    </Form>
            }
        </Modal>
    )
}